// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "arrow_next-jagRA arrow_next-1RFeq";
var _3 = "arrow_prev-2J-iA";
export { _1 as "__esModule", _2 as "arrow_next", _3 as "arrow_prev" }
export default { "__esModule": _1, "arrow_next": _2, "arrow_prev": _3 }
